// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import CartDropdown from './CartDropdown'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
import NotificationDropdown from './NotificationDropdown'

// ** Third Party Components
import { Sun, Moon, Plus, Star } from 'react-feather'
import { NavItem, NavLink } from 'reactstrap'
import { useState } from 'react'
import { ModalContext } from '../../../../views/components/contactform/ModalContext'
import { ContactModal } from '../../../../views/components/contactform/ContactModal'

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin } = props
  // ** Function to toggle Theme (Light/Dark)
  const [statusModal, setStatusModal] = useState(false)

  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  return (
    <ul className='nav navbar-nav align-items-center ml-auto'>
      {/* <IntlDropdown /> */}
      {/* <NavItem className='d-none d-lg-block'>
        <ModalContext.Provider value={{ statusModal, setStatusModal }} >
          <NavLink className='nav-link-style' onClick={(e) => { e.preventDefault(); setStatusModal(!statusModal) }}>
            <button className='btn btn-success'>Contacta con nosotros </button>
          </NavLink>
          <ContactModal title={'Descripción del cambio'} />
        </ModalContext.Provider>
      </NavItem> */}
      {/* <NavItem className='d-none d-lg-block'>
        <NavLink className='nav-link-style'>
          <ThemeToggler />
        </NavLink>
      </NavItem> */}

      {/* <NavbarSearch /> */}
      {/* <CartDropdown /> */}
      {/* <NotificationDropdown /> */}
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser
